import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { CreateLoadBalancerPage } from '@/routes/load-balancers/create-load-balancer/page'

export const CreateLoadBalancer = () => {
  return (
    <PageErrorBoundary>
      <CreateLoadBalancerPage />
    </PageErrorBoundary>
  )
}
